import { Injectable, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {SectorTypeApi } from '../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../theme/services/baToastNotification';

@Component({
  selector: 'app-sector-types',
  templateUrl: './sector-types.component.html',
  styleUrls: ['./sector-types.component.scss'],
  providers:[SectorTypeApi,BaToastNotificationService]
})

@Injectable()
export class SectorTypesComponent implements OnInit {

  private sectorTypeSource = new BehaviorSubject<object>({})
  sector_type = this.sectorTypeSource.asObservable();

  private sectorTypesSource = new BehaviorSubject<object>([])
  sector_types = this.sectorTypesSource.asObservable();

  private totalItemsSource = new BehaviorSubject<number>(0)
  total_items = this.totalItemsSource.asObservable();

  private pSource = new BehaviorSubject<number>(1) // first page
  p = this.pSource.asObservable();

  private itemsPerPageSource = new BehaviorSubject<number>(10)
  itemsPerPage = this.itemsPerPageSource.asObservable();// number of items per page

  private searchingSource = new BehaviorSubject<boolean>(false)
  searching = this.searchingSource.asObservable();

  private editedIdSource = new BehaviorSubject<number>(null)
  editedId = this.editedIdSource.asObservable();

  constructor(protected sectorTypeService:SectorTypeApi,private toast: BaToastNotificationService) { }

  ngOnInit() {
    this.getSectorTypes(this.pSource.getValue());
    this.getCount();
  }

  refresh(){
    this.pSource.next(1);
    this.getSectorTypes(this.pSource.getValue());
    this.editedIdSource.next(null);
    this.getCount();
  }

  getSectorTypes(page: number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorTypeService.find({
      order: "id DESC",
      include: ['sector'],
      limit: this.itemsPerPageSource.getValue(),
      skip: skip
    })
        .subscribe((res) => {
              this.sectorTypesSource.next(res);
            },
            ((error) => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            }))
  }

  getCount(){
    this.sectorTypeService.count().subscribe((res) => {
      if(res)
        this.totalItemsSource.next(res.count);
    })
  }

  search(term: string, page:number){
    let skip = ( page - 1) * this.itemsPerPageSource.getValue();
    this.sectorTypeService.search(term, this.itemsPerPageSource.getValue(), skip)
        .subscribe( results => {
              this.totalItemsSource.next(results.data.total);
              this.sectorTypesSource.next(results.data.sector_types);
              this.searchingSource.next(false);
            },
            err => {
              this.toast.error({
                heading: 'Error',
                text: 'Something went wrong. Reload to try again.',
                stack: 3
              });
            })
  }

  updateSectorTypeSource(data){
    this.sectorTypeSource.next(data);
    this.editedIdSource.next(data.id);
  }

  cancelSelected(){
    this.editedIdSource.next(null);
    this.sectorTypeSource.next({});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sector-types/sector-types.component.ts